import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  loading,
  decoding = "async",
  ...props
}) {
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      decoding={decoding}
      onError={(e) => {
        // Fallback removed: do not replace with placeholder; leave failed image
        // e.target.src = "/assets/images/no_image.png";
      }}
      {...props}
    />
  );
}

export default Image;
